/**
 * Deep-link to AI Project Builder for adding tasks to an existing project.
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {{ _id: string, name?: unknown, start_date?: unknown, end_date?: unknown }} snapshot
 */
export function navigateToAiProjectBuilderForExistingProject(navigate, snapshot) {
  if (!snapshot?._id) return;
  const id = String(snapshot._id).trim();
  if (!id) return;
  const params = new URLSearchParams();
  params.set("existingProjectId", id);
  navigate("/AIProjectBuilder?" + params.toString(), {
    state: {
      aiBuilderExistingProject: {
        _id: id,
        name: snapshot.name,
        start_date: snapshot.start_date,
        end_date: snapshot.end_date,
      },
    },
  });
}
